import { useMemo } from "react";
import HexagonCluster from "@/components/icons/HexagonCluster";
import { useNavigatorSelection } from "@/components/navigator/hooks";
import { LearnerOutcomeOverview } from "@/components/navigator/LearnerOutcomeOverview";
import {
  LearnerOutcomeTab,
  LearnerOutcomeTabPanel,
} from "@/components/navigator/LearnerOutcomeTab";
import withLayout from "@/components/withLayout";
import { useEntities } from "@/contexts/entities/EntitiesContext";
import colors from "@/lib/static/colors";

const defaultStyles =
  "bg-white border-tab-border hover:bg-neutral-100 active:bg-tab-bg-press";
const selectedStyles = `bg-BG-20 border-BG-55`;

const NavigatorRoot = () => {
  const { learnerOutcomes, getLearnerOutcome } = useEntities();
  const { activeLearnerOutcomeId, changeSelection } = useNavigatorSelection();

  const selectedLearnerOutcome = useMemo(
    () =>
      activeLearnerOutcomeId ? getLearnerOutcome(activeLearnerOutcomeId) : null,
    [activeLearnerOutcomeId, getLearnerOutcome],
  );

  return (
    <div
      className="z-1 min-h-[calc(100vh-72px)] bg-stone-50 bg-opacity-50"
      id="landing"
    >
      <div className="hide-scroll-bar visible flex h-[96px] w-full flex-row items-center justify-start gap-2 overflow-x-auto overflow-y-hidden border-b border-stone-200 px-4 medium:px-6 large:justify-center">
        <button
          key="overview"
          className={`flex h-16 w-[146px] flex-shrink-0 flex-grow-0 items-center justify-start whitespace-normal rounded-full border p-0 ${
            !selectedLearnerOutcome ? selectedStyles : defaultStyles
          }`}
          onClick={() => changeSelection("")}
        >
          <div className="ml-4 flex h-full w-full items-center gap-3">
            <HexagonCluster
              className="h-[35px] w-[34px]"
              fill={colors["BG-55"]}
            />
            <div className="font-roobert text-sm font-medium leading-none">
              Overview
            </div>
          </div>
        </button>
        {learnerOutcomes.map((learnerOutcome) => (
          <LearnerOutcomeTab
            key={learnerOutcome.id}
            learnerOutcome={learnerOutcome}
            activeLearnerOutcomeId={activeLearnerOutcomeId}
            changeSelection={changeSelection}
          />
        ))}
      </div>
      {!!selectedLearnerOutcome ? (
        <LearnerOutcomeTabPanel
          key={selectedLearnerOutcome.id}
          learnerOutcome={selectedLearnerOutcome}
          changeCompetency={changeSelection}
        />
      ) : (
        <LearnerOutcomeOverview />
      )}
    </div>
  );
};

export default withLayout(NavigatorRoot);
